export const components: any = {
  Segmented: {
    itemHoverBg: "#ffffff",
    // itemHoverColor:"#00968D",
    itemSelectedBg: "rgba(0,150,141,0.1)",
    itemSelectedColor: "#00968D",
    // trackBg:"#ffffff",
    trackPadding: 5,
    itemColor: "#1E2022",
  },
  Tooltip: {
    controlHeight: 16,
    paddingSM: 4,
    paddingXS: 8,
  },
  Layout: {
    siderBg: "#0052d9",
    lightSiderBg: "#dd52d9",
    triggerBg: "#0052d9",
  },
  Menu: {
    itemBg:"0052d9",
    itemHoverColor:"#ffffff",
    itemColor:"rgba(255,255,255,.6)",
    itemSelectedBg:"rgba(255,255,255,.1)",
    itemSelectedColor:"rgba(255,255,255,.6)",
  },
  Table:{
    // cellPaddingBlockSM:5,
  }
};
